<div class="w-full">
  
  <!-- Video Player Header -->
  <div class="flex items-center justify-between p-2 mb-6 pb-2">
    <div class="flex items-center">
      <img src="../../../assets/icons/copilot-bot.png" class="h-10 w-10 mr-4" alt="Bot Icon" />
      <h2 class="text-xl font-bold text-[#1D4586]">Training Videos - {{ videoTitle }}</h2>
    </div>
    <button (click)="goBack()" class="text-sm font-semibold text-[#1D4586] border border-gray-200 px-4 py-2 rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
      &larr; Back to videos
    </button>
  </div>

  <!-- Real HTML5 Video Player -->
  <div class="w-full flex justify-center animate-fade-in border-none">
    <!-- Removed shadow-lg and ensured border-none -->
    <div class="relative w-full aspect-video bg-black rounded-xl flex items-center justify-center overflow-hidden border-none outline-none">
      
      <!-- Native Video Tag binding to the S3 Link -->
      <!-- Added style="border: none;" to override any global CSS -->
      <video *ngIf="videoLink" 
             [src]="videoLink" 
             controls 
             autoplay 
             class="w-full h-full border-none outline-none focus:outline-none ring-0"
             style="border: none;"
             controlsList="nodownload">
        Your browser does not support the video tag.
      </video>

      <!-- Fallback if no link is loaded -->
      <div *ngIf="!videoLink" class="text-gray-400 text-sm">
        Loading video...
      </div>
      
    </div>
  </div>

</div>